/*
 *
 * SavingWallet reducer
 *
 */

import { createReducer } from '@reduxjs/toolkit';
import { 
  getWalletSummary, 
  getWalletSummarySuccess, 
  getWalletSummaryError,
  getWalletTransactions,
  getWalletTransactionsSuccess,
  getWalletTransactionsError,
  setPreviousPoints,
  showMilestoneCelebration,
  hideMilestoneCelebration,
} from './actions';
import { WalletSummaryResponse, WalletTransactionsResponse } from '../../apischema/savingwallet';

export interface SavingWalletState {
  walletData: WalletSummaryResponse | null;
  transactionsData: WalletTransactionsResponse | null; // This is the full response with data.history
  loading: boolean;
  transactionsLoading: boolean;
  error: string | null;
  transactionsError: string | null;
  previousPoints: number;
  milestoneToShow: number | null;
  showingMilestone: boolean;
}

export const initialState: SavingWalletState = {
  walletData: null,
  transactionsData: null,
  loading: false,
  transactionsLoading: false,
  error: null,
  transactionsError: null,
  previousPoints: 0,
  milestoneToShow: null,
  showingMilestone: false,
};

const savingWalletReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getWalletSummary, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getWalletSummarySuccess, (state, action) => {
      state.loading = false;
      state.walletData = action.payload.data;
      state.error = null;
    })
    .addCase(getWalletSummaryError, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    })
    .addCase(setPreviousPoints, (state, action) => {
      state.previousPoints = action.payload.previousPoints;
    })
    .addCase(showMilestoneCelebration, (state, action) => {
      state.milestoneToShow = action.payload.milestone;
      state.showingMilestone = true;
    })
    .addCase(hideMilestoneCelebration, (state) => {
      state.milestoneToShow = null;
      state.showingMilestone = false;
    })
    .addCase(getWalletTransactions, (state) => {
      state.transactionsLoading = true;
      state.transactionsError = null;
    })
    .addCase(getWalletTransactionsSuccess, (state, action) => {
      state.transactionsLoading = false;
      state.transactionsData = action.payload.data;
      state.transactionsError = null;
    })
    .addCase(getWalletTransactionsError, (state, action) => {
      state.transactionsLoading = false;
      state.transactionsError = action.payload.error;
    });
});

export default savingWalletReducer;
